export enum PaymentusErrorCode {
  dialogCode = '90001',
  ExternalPageCode = '90002',
}
